<div class="row justify-content-md-center">
  <div class="col-sm-12 col-md-6 col-md-auto">

    <div class="sign__container">

      <div style="margin-bottom: 30px; text-align: center;">
        <a href="http://www.telego.com/" style="box-sizing: border-box; color: #2196F3; text-decoration: none;">
          <img alt="TeleGo" style="-ms-interpolation-mode: bicubic; max-width: 100%;"
               src="../../../assets/images/logo-with-slogan.svg">
        </a>
      </div>

      <div class="card card-default">

        <div class="card-body">
          <h4 class="card-title">{{title}}</h4>

          <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError" data-testid="callback-message">
            {{serverMessage}}
          </div>

          <div class="alert alert-success alert-dismissible" role="alert" *ngIf="!serverError" data-testid="callback-message">
            {{serverMessage}}
          </div>

          <button type="button"
                  mat-raised-button
                  color="primary"
                  *ngIf="canOpenApp"
                  data-testid="open-app-button"
                  style="margin-top: 20px; width: 100%;"
                  (click)="openDeepLink()">
            Open TeleGo App
          </button>

          <button type="button"
                  mat-raised-button
                  color="primary"
                  *ngIf="!canOpenApp"
                  style="margin-top: 20px; width: 100%;"
                  [routerLink]="loginUrl">
            Return to Sign In
          </button>

          <p class="sso-app-callback__meta text-muted text-center" *ngIf="canOpenApp">
            If the app does not open automatically, click the button above.
          </p>
        </div>

      </div>

      <p class="sign__extra text-muted text-center" style="font-size: 15px;">
        Try again? <a [routerLink]="loginUrl" style="font-size: 19px;">Sign In</a>.
      </p>

    </div>

  </div>
</div>

